export default {
  EXPORT_JOB_COMPLETE: 'job-output-complete',
  EXPORT_JOB_FEEDBACK: 'job-output-feedback'
}
